import { UcoastEl } from '@/scripts/core/UcoastEl'
import EmblaCarousel, {
	EmblaCarouselType,
	EmblaOptionsType,
} from 'embla-carousel'
import { TsDOM as q } from '@/scripts/core/TsDOM'
import { WheelGesturesPlugin } from 'embla-carousel-wheel-gestures'
import ClassNames from 'embla-carousel-class-names'
import AutoHeight from 'embla-carousel-auto-height'
import { getSectionHTMLForResource } from '@/scripts/core/cart-functions'

export class ProductSlider extends UcoastEl {
	static htmlSelector = 'product-slider'
	dynamicContentContainer: HTMLElement
	collectionUrl: string
	uniqueId: string
	defer: boolean
	initialized: boolean = false
	emblaApi?: EmblaCarouselType
	disableAutoHeight?: boolean = false
	private dots: HTMLButtonElement[] = []
	constructor() {
		super()
		this.defer = this.hasAttribute('data-uc-animate')
		if (this.hasAttribute('data-disable-auto-height')) {
			this.disableAutoHeight = true
		}
		this.dynamicContentContainer = q.rs(
			'[data-dynamic-content]',
			this
		)
		if(this.hasAttribute('data-collection-url')) this.collectionUrl = q.ra(this, 'data-collection-url')
		this.uniqueId = q.ra(this, 'data-unique-id')

		if (!this.defer) {
			// if the form is statically loaded, we need to initialize variantData outside the async flow

			void this.initializeSlider()
		}
	}

	override animateIn() {
		super.animateIn()
		void this.initializeSlider()
	}

	async renderDynamicContent() {
		if (!this.dynamicContentContainer) return
		const content = await getSectionHTMLForResource(
			this.collectionUrl,
			'dynamic-product-list'
		)
		if (!content) return
		const contentWithUniqueId = content.replaceAll(
			'_dynamic_section_id_',
			this.uniqueId
		)
		this.dynamicContentContainer.innerHTML = contentWithUniqueId
		window.setTimeout(() => {
			this.classList.add('loaded')
		}, 5)
	}

	async initializeSlider() {
		if (this.initialized) return
		if (this.defer) {
			await this.renderDynamicContent()
		}
		if(this.closest('.related-products-container')) {
			this.closest('.related-products-container')?.classList.remove('hidden')
		}
		const OPTIONS: EmblaOptionsType = {
			slidesToScroll: 'auto',
			align: 'center',
			containScroll: 'keepSnaps',
			dragFree: false,
			duration: this.dataset.duration ? Number(this.dataset.duration) : 0.1,
			dragThreshold: this.dataset.dragThreshold ? parseInt(this.dataset.dragThreshold) : 0.1,
		}

		const viewportNode = q.rs('.embla__viewport', this)
		try {
			if (this?.disableAutoHeight) {
				this.emblaApi = EmblaCarousel(viewportNode, OPTIONS, [
					WheelGesturesPlugin(),
					ClassNames(),
				])
			} else {
				this.emblaApi = EmblaCarousel(viewportNode, OPTIONS, [
					WheelGesturesPlugin(),
					ClassNames(),
					AutoHeight(),
				])
			}

			if (this.emblaApi) {

                if(this.querySelector('.embla__dots')) {
                    const emblaDots = q.rs('.embla__dots', this)
                    this.setupDots(emblaDots)
                }

				if(this.querySelector('.embla__scrollbar')) {
                    const scrollbarNode = q.rs('.embla__scrollbar', this)
                    this.setupScrollbar(scrollbarNode)
                }

				// this.emblaApi.on('scroll', this.onScroll.bind(this))
            }
		} catch (e) {
			console.error(e)
		}
		if (!this.defer) {

		}
		this.initialized = true
	}

	private setupDots(emblaDots: HTMLElement) {
		const slides = this.emblaApi?.slideNodes() || []
        const slideShow = this.dataset.slideShow || 1
        if(Number(slideShow) >= slides.length) return
        const createDots = () => {
            emblaDots.innerHTML = ''
            this.dots = []
            
            this.dots = Array.from({ length: slides.length }).map((_, index) => {
                const dot = document.createElement('button')
                dot.className = 'embla__dot'
                dot.style.width = `${100 / slides.length}%`
				dot.innerHTML = `<span class="visually-hidden">${index}</span>`
                dot.addEventListener('click', () => this.emblaApi?.scrollTo(index))
                emblaDots.appendChild(dot)
                return dot
            })
        }

        const updateDots = () => {
            const selectedIndex = this.emblaApi?.selectedScrollSnap() || 0
            this.dots.forEach((dot, index) => {
                dot.classList.toggle('embla__dot--selected', index === selectedIndex)
            })
        }

        createDots()
        updateDots()

        this.emblaApi?.on('select', updateDots)
    }

	private setupScrollbar(scrollbarNode: HTMLElement) {
		const enableScrollbar = this.dataset.scrollbar ? this.dataset.scrollbar == 'true' : false
        if(enableScrollbar) {
			const scrollbarThumb = q.rs('.embla__scrollbar__thumb', scrollbarNode)
			const slides = this.emblaApi?.slideNodes() || []
			const slideShow = this.dataset.mobileShow || 1
			if(slides.length > Number(slideShow)) {
				this.emblaApi?.on('scroll', () => {
					const range = scrollbarNode.offsetWidth - scrollbarThumb.offsetWidth
					const scorllProgress = Number(this.emblaApi?.scrollProgress())
					const thumbPosition = scorllProgress * range
					scrollbarThumb.style.transform = `translateX(${thumbPosition}%)`
				})
			} else {
				scrollbarNode.remove()
			}
		} else {
			scrollbarNode.remove()
		}
    }

	onScroll() {
		if(!this.emblaApi) return
        const scrollProgress = this.emblaApi.scrollProgress()
        if (scrollProgress >= 1 || scrollProgress <= 0) {
            this.emblaApi.internalEngine().translate.toggleActive(false)
        } else {
            this.emblaApi.internalEngine().translate.toggleActive(true)
        }
	}
}
